import { GoWorkflow, GoDatabase, GoGlobe, GoCommentDiscussion } from 'react-icons/go';
import { HiMiniArrowLeftStartOnRectangle, HiMiniArrowRightStartOnRectangle } from "react-icons/hi2";
import { LuBrainCircuit, LuTarget } from "react-icons/lu";
import { RiRobot2Line, RiDashboardLine } from "react-icons/ri";
import { PiChatText, PiChatsCircle, PiChatCircleDots, PiGraph, PiVectorThree } from "react-icons/pi";
import { FaCode, FaHtml5, FaChartLine } from "react-icons/fa6";
import { LuText } from "react-icons/lu";
import { TfiWidget } from "react-icons/tfi";
import { GiProcessor } from "react-icons/gi";

export default class Components {
  constructor() {
    this.componentIcons = [
      {"prefix": "flow.entered", "icon": <HiMiniArrowRightStartOnRectangle />},
      {"prefix": "flow.exited", "icon": <HiMiniArrowLeftStartOnRectangle />},
      {"prefix": "flow.", "icon": <GoWorkflow />},
      {"prefix": "data.", "icon": <GoDatabase />},
      {"prefix": "web.", "icon": <GoGlobe />},
      {"prefix": "genai.chat", "icon": <LuBrainCircuit />},
      {"prefix": "genai.agent", "icon": <RiRobot2Line />},
      {"prefix": "database.vector.", "icon": <PiVectorThree />},
      {"prefix": "logic.", "icon": <FaCode />},
      {"prefix": "text.", "icon": <LuText />},
      {"prefix": "widget.html", "icon": <FaHtml5 />},
      {"prefix": "widget.thread", "icon": <GoCommentDiscussion />},
      {"prefix": "widget.graph", "icon": <PiGraph />},
      {"prefix": "widget.tradingview", "icon": <FaChartLine />},
      {"prefix": "widget.messages", "icon": <PiChatsCircle />},
      {"prefix": "widget.message", "icon": <PiChatText />},
      {"prefix": "widget.chat", "icon": <PiChatCircleDots />},
      {"prefix": "widget.", "icon": <TfiWidget />},
      {"prefix": "system.work.missions", "icon": <LuTarget />},
      {"prefix": "system.", "icon": <RiDashboardLine />},
    ];
  }

  getComponentIcon(type) {
    for ( const icon of this.componentIcons ) {
      if ( type.startsWith(icon.prefix) ) {
        return icon.icon;
      }
    }
    return <GiProcessor />;
  }
}